

import esbBreadcrumb from './breadcrumb/View'

$vue.component('esb-breadcrumb', esbBreadcrumb);
